import React, { useRef } from "react";
import "./Modal.css"; // Ensure the CSS file is included

const Modal = ({ show, title, setShowModal, children }) => {
  const modalRef = useRef(null);
  if (!show) return null; // Prevents rendering when show is false

  const handleOverlayClick = () => {
    setShowModal(false);
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div
        ref={modalRef}
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ position: "absolute", cursor: "grab" }}
      >
        <button
          className="modal-cross-button"
          onClick={handleOverlayClick}
          aria-label="Close modal"
        >
          &times;
        </button>
        <div className="modal-title">{title}</div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
